import { render, staticRenderFns } from "./reorder.vue?vue&type=template&id=6c965068"
import script from "./reorder.vue?vue&type=script&lang=js"
export * from "./reorder.vue?vue&type=script&lang=js"
import style0 from "./reorder.vue?vue&type=style&index=0&id=6c965068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports